import { connect } from 'react-redux';
import TreatmentPanel from '../../../components/DailyPlanning/TreatmentPanel/TreatmentPanel';
import {
  getTreatmentInstances,
  getPostings,
  overrideTreatmentInstance,
  removeOverrideTreatmentInstance,
} from '../../../actions/entities';
import globals from '../../../globals/communityGlobals';
import { selectSelectedDate, selectSelectedTeam } from '../../../reducers/areas/dailyPlanning';
import { checkFeatureAccess } from '../../../utils/helpers';
import { selectSortedTreatmentInstancesWithBands } from '../../../reducers/entities/treatmentInstances/selectors';
import { autoAllocationStatuses } from '../../../settings/constants';

const mapStateToProps = state => {
  const {
    entities: { treatmentInstances },
    global: { auth },
    areas: {
      dailyPlanning: { autoAllocate },
    },
  } = state;
  const { isFetching, error } = treatmentInstances.general;
  const isAutoAllocating = autoAllocate.status !== autoAllocationStatuses.IDLE;
  const autoAllocateDate = autoAllocate.date;
  const autoAllocateTeamId = autoAllocate.teamIdisUnAllocating;

  return {
    isAutoAllocating,
    autoAllocateDate,
    autoAllocateTeamId,
    selectedDate: selectSelectedDate(state),
    selectedTeam: selectSelectedTeam(state),
    isFetching,
    treatmentInstances: selectSortedTreatmentInstancesWithBands(state),
    error,
    canAllocateWork: checkFeatureAccess(auth.featureAccessList, globals.applicationFeatureAccesses.canAllocateWork),
  };
};

const mapDispatchToProps = dispatch => ({
  fetchPostings: forceUpdate => dispatch(getPostings(forceUpdate)),
  overrideClinician: async (treatmentId, treatmentInstanceId, on, timeSlots) => {
    if (globals.now.isSameOrBefore(on, 'day')) {
      await dispatch(overrideTreatmentInstance(treatmentId, treatmentInstanceId, on, timeSlots));
    }

    dispatch(getTreatmentInstances(true, true));
  },
  removeOverrideClinician: async (treatmentInstanceId, on) => {
    if (globals.now.isSameOrBefore(on, 'day')) {
      await dispatch(removeOverrideTreatmentInstance(treatmentInstanceId));
    }

    dispatch(getTreatmentInstances(true, true));
  },
});

const TreatmentPanelContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(TreatmentPanel);

export default TreatmentPanelContainer;
